/**
 * Система логирования с уровнями для оптимизации в продакшене
 */

const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  NONE: 4
};

// Определяем уровень логирования из переменной окружения или по умолчанию
const getLogLevel = () => {
  if (typeof window !== 'undefined') {
    // В браузере проверяем URL параметры или localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const debugParam = urlParams.get('debug');
    if (debugParam === 'true' || localStorage.getItem('debug') === 'true') {
      return LOG_LEVELS.DEBUG;
    }
    // В продакшене только ошибки и предупреждения
    return import.meta.env.PROD ? LOG_LEVELS.WARN : LOG_LEVELS.INFO;
  }
  return LOG_LEVELS.INFO;
};

const currentLogLevel = getLogLevel();

/**
 * Проверяет, нужно ли логировать на данном уровне
 */
function shouldLog(level) {
  return level >= currentLogLevel;
}

/**
 * Логирование с уровнями
 */
export const logger = {
  debug: (...args) => {
    if (shouldLog(LOG_LEVELS.DEBUG)) {
      console.log('[DEBUG]', ...args);
    }
  },
  
  info: (...args) => {
    if (shouldLog(LOG_LEVELS.INFO)) {
      console.log('[INFO]', ...args);
    }
  },
  
  warn: (...args) => {
    if (shouldLog(LOG_LEVELS.WARN)) {
      console.warn('[WARN]', ...args);
    }
  },
  
  error: (...args) => {
    if (shouldLog(LOG_LEVELS.ERROR)) {
      console.error('[ERROR]', ...args);
    }
  },
  
  // Специальные логи для важных событий (всегда логируются)
  critical: (...args) => {
    console.error('[CRITICAL]', ...args);
  }
};

/**
 * Утилита для проверки типа функции (оптимизированная)
 */
export function isFunction(fn) {
  return typeof fn === 'function';
}

/**
 * Утилита для безопасного вызова функции
 */
export function safeCall(fn, ...args) {
  if (isFunction(fn)) {
    try {
      return fn(...args);
    } catch (error) {
      logger.error('Error in safeCall:', error);
      return null;
    }
  }
  return null;
}

/**
 * Утилита для проверки наличия объекта и его свойств
 */
export function hasProperty(obj, ...props) {
  if (!obj || typeof obj !== 'object') return false;
  for (const prop of props) {
    if (!(prop in obj)) return false;
  }
  return true;
}

export default logger;




